/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Text`)
};

const es_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Texto`)
};

const de_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Text`)
};

const nl_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Tekst`)
};

const fr_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Text`)
};

const it_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Text`)
};

const pt_br2_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Texto`)
};

const pt_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Texto`)
};

const ja_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モールス → テキスト`)
};

const zh_mc_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse → Text`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_mode_decode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_mode_decode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_mode_decode", locale)
	if (locale === "en") return en_mc_mode_decode(inputs)
	if (locale === "es") return es_mc_mode_decode(inputs)
	if (locale === "de") return de_mc_mode_decode(inputs)
	if (locale === "nl") return nl_mc_mode_decode(inputs)
	if (locale === "fr") return fr_mc_mode_decode(inputs)
	if (locale === "it") return it_mc_mode_decode(inputs)
	if (locale === "pt-BR") return pt_br2_mc_mode_decode(inputs)
	if (locale === "pt") return pt_mc_mode_decode(inputs)
	if (locale === "ja") return ja_mc_mode_decode(inputs)
	return zh_mc_mode_decode(inputs)
};